import type { NavButtonAboutProps } from "./nav-button-about.type";

import { NavButton } from "@/modules/nav-button";
import { useNavigationActionAbout } from "@/modules/navigation";

export const NavButtonAbout = ({ title, className }: NavButtonAboutProps) => {
  const { icon, text, runAction } = useNavigationActionAbout();

  return (
    <NavButton
      title={title ?? text}
      onClick={runAction}
      icon={icon}
      className={className}
    />
  );
};
